var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "resolve",
      attrs: { "aria-labelledby": "rpd-resolve-heading" },
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "resolve__grid" }, [
        _c("div", { staticClass: "resolution", class: _vm.primaryState.cls }, [
          _vm._m(2),
          _vm._v(" "),
          _c("p", { staticClass: "resolution__value" }, [
            _c(
              "i",
              {
                staticClass: "material-icons",
                attrs: { "aria-hidden": "true" },
              },
              [_vm._v(_vm._s(_vm.primaryState.icon))]
            ),
            _vm._v("\n        " + _vm._s(_vm.primaryState.word) + "\n      "),
          ]),
          _vm._v(" "),
          _vm.primaryIds.length
            ? _c(
                "div",
                { staticClass: "resolution__ids" },
                _vm._l(_vm.primaryIds, function (id) {
                  return _c(
                    "span",
                    { key: id, staticClass: "chip chip--mono" },
                    [_vm._v(_vm._s(id))]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c("p", { staticClass: "resolution__meta" }, [
            _vm._v(_vm._s(_vm.primaryMeta)),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "resolution", class: _vm.duplicateState.cls },
          [
            _vm._m(3),
            _vm._v(" "),
            _c("p", { staticClass: "resolution__value" }, [
              _c(
                "i",
                {
                  staticClass: "material-icons",
                  attrs: { "aria-hidden": "true" },
                },
                [_vm._v(_vm._s(_vm.duplicateState.icon))]
              ),
              _vm._v(
                "\n        " + _vm._s(_vm.duplicateState.word) + "\n      "
              ),
            ]),
            _vm._v(" "),
            _vm.duplicateIds.length
              ? _c(
                  "div",
                  { staticClass: "resolution__ids" },
                  _vm._l(_vm.duplicateIds, function (id) {
                    return _c(
                      "span",
                      { key: id, staticClass: "chip chip--mono" },
                      [_vm._v(_vm._s(id))]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c("p", { staticClass: "resolution__meta" }, [
              _vm._v(_vm._s(_vm.duplicateMeta)),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "identity" }, [
        _c("div", { staticClass: "identity__head" }, [
          _c(
            "i",
            { staticClass: "material-icons", attrs: { "aria-hidden": "true" } },
            [_vm._v("compare_arrows")]
          ),
          _vm._v(" "),
          _c("h3", [_vm._v("Do the filters separate the two sides?")]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "chip identity__verdict",
              class: _vm.identity.collides ? "chip--error" : "chip--success",
            },
            [
              _c(
                "i",
                {
                  staticClass: "material-icons",
                  attrs: { "aria-hidden": "true" },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.identity.collides ? "error_outline" : "check_circle"
                    )
                  ),
                ]
              ),
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.identity.collides
                      ? "Filters describe one sample"
                      : "Filters differ"
                  ) +
                  "\n      "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "identity__row" }, [
          _c("span", { staticClass: "identity__label" }, [
            _vm._v("Monitoring location"),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "identity__value" }, [
            _vm._v(_vm._s(_vm.identity.locationPrimary)),
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "identity__cmp", attrs: { "aria-hidden": "true" } },
            [_vm._v(_vm._s(_vm.identity.locationSame ? "=" : "≠"))]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "identity__value" }, [
            _vm._v(_vm._s(_vm.identity.locationDuplicate)),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "chip chip--neutral identity__flag" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.identity.locationSame ? "Same" : "Differs") +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "identity__row" }, [
          _c("span", { staticClass: "identity__label" }, [
            _vm._v("QA/QC aliases"),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "identity__value" }, [
            _vm._v(_vm._s(_vm.identity.aliasPrimary)),
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "identity__cmp", attrs: { "aria-hidden": "true" } },
            [_vm._v(_vm._s(_vm.identity.aliasesSame ? "=" : "≠"))]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "identity__value" }, [
            _vm._v(_vm._s(_vm.identity.aliasDuplicate)),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "chip chip--neutral identity__flag" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.identity.aliasesSame ? "Same" : "Differs") +
                "\n      "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("RpdVerdictBand", { attrs: { band: _vm.band, live: "" } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "resolve__head" }, [
      _c("h2", { attrs: { id: "rpd-resolve-heading" } }, [
        _vm._v("Resolved samples"),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "chip chip--info" }, [
        _c(
          "i",
          { staticClass: "material-icons", attrs: { "aria-hidden": "true" } },
          [_vm._v("lock")]
        ),
        _vm._v("\n      One sample per side\n    "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "resolve__lede" }, [
      _vm._v(
        "\n    What each side's filters matched. Export unlocks only when "
      ),
      _c("em", [_vm._v("both")]),
      _vm._v(" sides resolve to\n    exactly one distinct "),
      _c("code", [_vm._v("ClientSampleID")]),
      _vm._v(".\n  "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "resolution__head" }, [
      _c(
        "span",
        {
          staticClass: "role-badge role-badge--primary",
          attrs: { "aria-hidden": "true" },
        },
        [_vm._v("P")]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "resolution__label" }, [_vm._v("Primary")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "resolution__head" }, [
      _c(
        "span",
        {
          staticClass: "role-badge role-badge--duplicate",
          attrs: { "aria-hidden": "true" },
        },
        [_vm._v("D")]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "resolution__label" }, [_vm._v("Duplicate")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }